<template>
  <div class="index">
    <div class="carousel" style="margin-top: 70px">
      <tiny-carousel arrow="never" height="600px" :interval="5000" autoplay>
        <tiny-carousel-item v-for="item of bannerList" :key="item.title">

          <tiny-image :src="item.imgUrls" fit="cover">

          </tiny-image>
        </tiny-carousel-item>
      </tiny-carousel>
    </div>
    <HomePart2 :info="homeInfo.serviceH1"></HomePart2>
    <HomePart3 :info="homeInfo.produceH1"></HomePart3>
    <HomePart4 :info="homeInfo.newsH1"></HomePart4>
    <HomePart1 :info="homeInfo.aboutusH1"></HomePart1>
    <HomePart5 :info="homeInfo.developH1"></HomePart5>
    <HomePart6 :info="homeInfo.customersH1"></HomePart6>
    <HomePart7 :phone="phone"></HomePart7>
  </div>
</template>

<script>
import '@/assets/styles/header.css'

import { NavMenu, Carousel, CarouselItem, Image, Floatbar  } from '@opentiny/vue'
import HomePart1 from "@/components/HomePart1.vue";
import HomePart2 from "@/components/HomePart2.vue";
import HomePart3 from "@/components/HomePart3.vue";
import HomePart4 from "@/components/HomePart4.vue";
import HomePart5 from "@/components/HomePart5.vue";
import HomePart6 from "@/components/HomePart6.vue";
import HomePart7 from "@/components/HomePart7.vue";
import N6 from "@/components/N6.vue";
import Footer from "@/components/Footer.vue";
import Right from "@/components/Right.vue";
import request from "@/utils/request";

export default {
  name: "index",
  components: {
    HomePart1,
    HomePart2,
    HomePart3,
    HomePart4,
    HomePart5,
    HomePart6,
    HomePart7,
    Footer,
    N6,
    TinyNavMenu: NavMenu,
    TinyCarousel: Carousel,
    TinyCarouselItem: CarouselItem,
    TinyImage: Image,
    TinyFloatbar: Floatbar
  },
  data() {
    return {
      bannerHeight: '600px',
      bannerList: [],
      phone: '',
      homeInfo: {
        serviceH1: '',
        produceH1: '',
        newsH1: '',
        aboutusH1: '',
        developH1: '',
        customersH1: '',
      },
    };
  },
  created() {
    this.queryBannerList();
    this.queryHomeH1();
    this.queryCompanyInfo();

    window.addEventListener(
        "resize",
        () => {
          this.setSize();
        },
        false
    );

    if(sessionStorage.getItem("phone")){
      this.phone = sessionStorage.getItem("phone");
    }
  },
  mounted() {
    // 首次加载时,需要调用一次
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () =>{
      this.setSize();
    }
  },


  methods: {
    async queryBannerList() {
      const {data} = await request.get("/outSiteMenu/queryBannerList")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.bannerList = data.data;
      }
    },

    async queryHomeH1() {
      const {data} = await request.get("/outSiteMenu/queryHomeH1")
      if (data.code === 200 && data.data) {
        this.homeInfo = data.data;
      }
    },

    async queryCompanyInfo() {
      const {data} = await request.get("/outSiteMenu/queryCompanyInfo")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.phone = data.data.phone;
      }
    },

    setSize() {
      this.bannerHeight = document.body.clientWidth / 3.2; //这个比例是1920/500
      this.$nextTick(()=>{
        this.bannerHeight = document.body.clientWidth / 3.2; //这个比例是1920/500
      })
    },
  },

};
</script>

<style scoped>

</style>
